type KpiStripProps = {
  total: number;
  reconciled: number;
  withProblems: number;
};

const KPI_ITEMS = (props: KpiStripProps) => [
  { label: 'Rows in file', value: props.total, tone: 'text-gray-900' },
  { label: 'Reconciled', value: props.reconciled, tone: 'text-emerald-700' },
  { label: 'With problems', value: props.withProblems, tone: 'text-red-700' },
];

export const KpiStrip = (props: KpiStripProps) => (
  <div
    role="status"
    aria-live="polite"
    className="flex items-stretch gap-3 px-6 py-4 [@media(max-height:820px)]:py-2"
  >
    {KPI_ITEMS(props).map((kpi) => (
      <div
        key={kpi.label}
        className="flex-1 rounded-xl border border-gray-200 bg-white px-4 py-3 [@media(max-height:820px)]:flex [@media(max-height:820px)]:items-baseline [@media(max-height:820px)]:gap-2 [@media(max-height:820px)]:py-1.5"
      >
        <p className="text-xs text-gray-500">{kpi.label}</p>
        <p className={`text-2xl font-semibold ${kpi.tone} [@media(max-height:820px)]:text-lg`}>{kpi.value}</p>
      </div>
    ))}
  </div>
);
